module.exports = __webpack_public_path__ + "static/img/coupon_received2@3x.29bd5742.png";